import state from "./moduleBookingStatusState.js";
import mutations from "./moduleBookingStatusMutations.js";
import actions from "./moduleBookingStatusActions.js";
import getters from "./moduleBookingStatusGetters.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
